// Fichier: frontend/src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import MeetingListView from "../views/MeetingListView.vue";
import MeetingDetailView from "../views/MeetingDetailView.vue";
import NewMeetingView from "../views/NewMeetingView.vue";
import EditMeetingView from "../views/EditMeetingView.vue"; // Importez la nouvelle vue

const routes = [
  {
    path: "/",
    name: "MeetingList",
    component: MeetingListView,
  },
  {
    path: "/meeting/:id",
    name: "MeetingDetail",
    component: MeetingDetailView,
    props: true, // Permet de passer l'ID du paramètre d'URL comme une prop au composant
  },
  {
    path: "/new-meeting",
    name: "NewMeeting",
    component: NewMeetingView,
  },
  {
    path: "/edit-meeting/:id", // Nouvelle route d'édition
    name: "EditMeeting",
    component: EditMeetingView,
    props: true, // Passe l'ID comme prop
  },
  // Ajoutez d'autres routes ici
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
